import { useState, useEffect } from 'react';

export const useDebounce = (value, delay) => {
    const [ debouncedValue, setDebouncedValue ] = useState(value);
    //const [ spinnerState, setSpinnerState ] = useState(false);

    useEffect(
        () => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
                //setSpinnerState(true);
            }, delay);
            return () => {
                clearTimeout(handler);
            };
        }, [value]);
    return debouncedValue;

};